import {
  Checkbox as AntCheckbox,
  type CheckboxOptionType as AntCheckboxOptionType,
  type CheckboxProps as AntCheckboxProps
} from 'antd';
import React from 'react';

import './Checkbox.less';

type CheckboxProps = Pick<
  AntCheckboxProps,
  'checked' | 'children' | 'disabled' | 'id' | 'onChange' | 'value'
>;

type CheckboxValueType = AntCheckboxOptionType['value'];

type CheckboxChangeEvent = Parameters<NonNullable<CheckboxProps['onChange']>>[0];

function Checkbox(props: CheckboxProps): JSX.Element {
  return <AntCheckbox {...props} className="Checkbox" />;
}

const CheckboxWithGroup = Object.assign(Checkbox, {
  Group: AntCheckbox.Group
});

export default CheckboxWithGroup;
export type {
  CheckboxChangeEvent,
  CheckboxProps,
  CheckboxValueType
};
